import { render, staticRenderFns } from "./ProductSelectModal.vue?vue&type=template&id=4028b3a9&scoped=true"
import script from "./ProductSelectModal.vue?vue&type=script&lang=js"
export * from "./ProductSelectModal.vue?vue&type=script&lang=js"
import style0 from "./ProductSelectModal.vue?vue&type=style&index=0&id=4028b3a9&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_j7knk6mol3vthgvrc443rvn57u/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4028b3a9",
  null
  
)

export default component.exports